import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingUsers: false,
  loadingChangePassword: false,
  loadingUpdateProfile: false,
  loadingUserStatistics: false,
  users: [],
  pagination: {
    page: 1,
    limit: 10,
    total: -1,
  },
  statistics: {
    totalCustomers: 0,
    newSignupsThisMonth: 0,
    activeCustomers: 0,
    activeCustomersPercentage: 0,
    newSignupsToday: 0,
    lastUpdated: null,
  },
  affiliates: [],
  tags: [],
  profiles: [],
  loadingCreateUserList: false,
  loadingExportUserList: false,
  loadingVerifyDepositMatchEligibility: false,
});

export default {
  namespaced: true,

  state: initState(),

  mutations: {
    LOAD_USER_LIST: (s, data) => (s.loadingUsers = data),
    LOAD_CHANGE_PASSWORD: (s, data) => (s.loadingChangePassword = data),
    LOAD_UPDATE_PROFILE: (s, data) => (s.loadingUpdateProfile = data),
    SET_USERS: (s, data) => {
      s.users = data.users;
      s.pagination = data.pagination;
    },
    SET_USER_STATISTICS: (s, data) => {
      s.statistics = data;
    },
    LOAD_USER_STATISTICS: (s, data) => (s.loadingUserStatistics = data),
    SET_AFFILIATES: (s, data) => (s.affiliates = data),
    SET_TAGS: (s, data) => (s.tags = data),
    LOAD_CREATE_USER_LIST: (s, data) => (s.loadingCreateUserList = data),
    SET_PROFILES: (s, data) => (s.profiles = data),
    LOAD_EXPORT_USER_LIST: (s, data) => (s.loadingExportUserList = data),
    LOAD_VERIFY_DEPOSIT_MATCH_ELIGIBILITY: (s, data) =>
      (s.loadingVerifyDepositMatchEligibility = data),
  },

  actions: {
    async getUserList({ commit }, params) {
      commit("LOAD_USER_LIST", true);
      try {
        const res = await this.$api.get("/v1/portal/users", { params });
        const { data, pagination } = res.data;
        commit("SET_USERS", {
          users: data,
          pagination,
        });
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_USER_LIST", false);
      }
    },
    async changePassword({ commit }, param) {
      commit("LOAD_CHANGE_PASSWORD", true);

      const { userId, ...rest } = param;

      try {
        const res = await this.$api.put(
          `/v1/portal/users/${userId}/reset-password`,
          rest,
        );

        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CHANGE_PASSWORD", false);
      }
    },
    async updateUserProfile({ commit }, param) {
      commit("LOAD_UPDATE_PROFILE", true);

      const { userId, ...rest } = param;

      try {
        const res = await this.$api.put(`/v1/portal/users/${userId}`, rest);

        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPDATE_PROFILE", false);
      }
    },
    async getUserStatistics({ commit }) {
      try {
        commit("LOAD_USER_STATISTICS", true);
        const { data: res } = await this.$api.get(
          "/v1/portal/users/statistics/all",
        );
        commit("SET_USER_STATISTICS", res.data);
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_USER_STATISTICS", false);
      }
    },
    async getAffiliates({ commit }) {
      try {
        const { data: res } = await this.$api.get(
          "/v1/portal/affiliates?limit=100",
        );
        commit("SET_AFFILIATES", res.data);
      } catch (e) {
        errorHandler(e);
      }
    },
    async getTags({ commit }) {
      try {
        const { data: res } = await this.$api.get("/v1/portal/tags");
        commit("SET_TAGS", res.data);
      } catch (e) {
        errorHandler(e);
      }
    },
    async getProfileList({ commit }) {
      try {
        const { data: res } = await this.$api.get("/v1/profile-types/");
        commit("SET_PROFILES", res.data);
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async createUserList({ commit }, params) {
      try {
        commit("LOAD_CREATE_USER_LIST", true);
        const { data: res } = await this.$api.post(
          "/v1/portal/users/lists",
          params,
        );
        return res;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_USER_LIST", false);
      }
    },
    async getUserListByGroup({ commit }, listId) {
      try {
        commit("LOAD_CREATE_USER_LIST", true);
        const { data: res } = await this.$api.get(
          `/v1/portal/users/lists/${listId}`,
        );
        return res;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_USER_LIST", false);
      }
    },
    async exportUserList({ commit }, params) {
      commit("LOAD_EXPORT_USER_LIST", true);
      try {
        const res = await this.$api.get("/v1/portal/users/export", { params });
        const { data, pagination } = res.data;
        // commit("SET_USERS", {
        //   users: data,
        //   pagination,
        // });
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_EXPORT_USER_LIST", false);
      }
    },
    async assignMultiAffiliate({}, payload) {
      try {
        const { data: res } = await this.$api.put(
          `/v1/portal/users/affiliate/assign`,
          payload,
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async getUserListBrief({ commit }, params) {
      commit("LOAD_USER_LIST", true);
      try {
        const res = await this.$api.get("/v1/portal/users/search-brief", {
          params,
        });
        const { data, pagination } = res.data;
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_USER_LIST", false);
      }
    },
    async verifyDepositMatchEligibility({ commit }, params) {
      commit("LOAD_VERIFY_DEPOSIT_MATCH_ELIGIBILITY", true);
      try {
        const res = await this.$api.get(
          `/v1/portal/deposit-match/verify/${params}`,
        );
        const { data, pagination } = res.data;
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_VERIFY_DEPOSIT_MATCH_ELIGIBILITY", false);
      }
    },
  },
};
